import api from "./api";

const route = "/brands";

const BrandsService = {
  getBrands: () => api.get(route)
};

export default BrandsService;

